import appConfig from '../config/appConfig';

const getIsLocked = (isLocked) => appConfig.getIsParentProtectionEnabled() && isLocked;

export default {
    getIsLocked,
};
